import { type FC } from 'react';
import useNotificationApi from '../../../../../../_helpers/hooks/useNotificationApi.ts';
import './MarkAllButton.scss';
import type { NotificationsData } from '../../../../../../../../../../components/blackrock/advisor-center/_types/header.ts';

type Props = {
	apiResult: ReturnType<typeof useNotificationApi>;
	notificationsData: NotificationsData;
	forceDisability: boolean;
};

const MarkAllButton: FC<Props> = ({
	apiResult: { markAllAsRead },
	forceDisability,
	notificationsData: {
		markAllAsReadItem: { displayValue, dataLinkEvent, ariaLabel },
	},
}) => {
	const onClick = markAllAsRead && !forceDisability ? markAllAsRead : undefined;

	return (
		<button
			className="mark-all-as-read-button"
			onClick={onClick}
			disabled={!onClick}
			tabIndex={0} // Safari does not include button in tab order if tabIndex is not set
			data-link-event={dataLinkEvent}
			aria-label={ariaLabel}
		>
			{displayValue}
		</button>
	);
};

export default MarkAllButton;
